import { useState } from "react";
import {
  QueueProcessItemType,
  QueueProcessValueType,
  QueueProcessUpdateDataType,
} from "../types";

export function useQueueProcess() {
  const [processItems, setProcessItems] = useState<QueueProcessItemType[]>([]);

  function updateQueueProcessById<DataType, ResultType>(
    processId: QueueProcessItemType<DataType, ResultType>["key"],
    data: QueueProcessUpdateDataType<DataType, ResultType>,
  ) {
    setProcessItems((process) =>
      process.map((item) => {
        if (item.key === processId) {
          return typeof data === "function"
            ? { ...data(item), ...item }
            : { ...item, ...data };
        }
        return item;
      }),
    );
  }

  const findProcessById = (processId: QueueProcessItemType["key"]) => {
    return processItems.find((item) => item.key === processId);
  };

  function addProcess<DataType, ResultType>({
    key,
    data,
    promise,
  }: QueueProcessValueType<DataType, ResultType>): QueueProcessItemType {
    const currentProcess: QueueProcessItemType<DataType, ResultType> = {
      key,
      status: "loading",
      data: data,
      promise: promise,
    };

    currentProcess.promise
      .then(() => {
        updateQueueProcessById(key, {
          status: "success",
        });
      })
      .catch((error) => {
        updateQueueProcessById(key, {
          status: "error",
          error: error,
        });
      });

    setProcessItems((process) => {
      process.unshift(currentProcess);
      return [...process];
    });

    return currentProcess;
  }

  return {
    processItems,
    addProcess,
    findProcessById,
    updateQueueProcessById,
  };
}
